export const TOKEN_KEY = 'accessToken'
export const FIREBASE_TOKEN_KEY = 'firebaseToken'

const isBrowser = (): boolean => Object.is(typeof window, 'object')

class StorageClass {
  private justString: string[]

  public constructor() {
    this.justString = [TOKEN_KEY, FIREBASE_TOKEN_KEY]
  }

  public getItem(key: string): string | undefined {
    try {
      const serialized = isBrowser() ? localStorage.getItem(key) : null

      if (serialized === null) {
        return undefined
      }
      return this.justString.includes(key) ? serialized : JSON.parse(serialized)
    } catch (err) {
      console.warn(err) // eslint-disable-line no-console
      return undefined
    }
  }

  public setItem(key: string, value: string): void {
    try {
      const serialized = this.justString.includes(key) ? value : JSON.stringify(value)
      if (isBrowser()) {
        localStorage.setItem(key, serialized)
      }
    } catch (err) {
      console.warn(err) // eslint-disable-line no-console
    }
  }

  public removeItem(key: string): void {
    if (isBrowser()) {
      localStorage.removeItem(key)
    }
  }
}

const Storage = new StorageClass()

export default Storage
